module.exports = __webpack_public_path__ + "img/p2m-logo.e5c39c20.jpg";